"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _simplSchema = _interopRequireDefault(require("simpl-schema"));

var _createSchemaBridge = _interopRequireDefault(require("uniforms/createSchemaBridge"));

var _filterDOMProps = _interopRequireDefault(require("uniforms/filterDOMProps"));

var _SimpleSchema2Bridge = _interopRequireDefault(require("./SimpleSchema2Bridge"));

// Register bridge.
_createSchemaBridge["default"].register(_SimpleSchema2Bridge["default"]); // Register custom property.


_simplSchema["default"].extendOptions(['uniforms']); // There's no possibility to retrieve them at runtime


_filterDOMProps["default"].register('allowedValues', 'autoValue', 'blackbox', 'custom', 'decimal', 'defaultValue', 'exclusiveMax', 'exclusiveMin', 'label', 'max', 'maxCount', 'min', 'minCount', 'optional', 'regEx', 'trim', 'type');